// extracted by mini-css-extract-plugin
export default {"page":"homePage_page__X3r-A"};